import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Temporal.io connector can link workflows and workflow history to PostHog.`}</p>
    <p>{`To link Temporal.io:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Go to the `}<a parentName="p" {...{
            "href": "https://us.posthog.com/pipeline/sources"
          }}>{`sources tab`}</a>{` of the data pipeline section in PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`+ New source`}</strong>{` and then click `}<strong parentName="p">{`Link`}</strong>{` next to Temporal.io.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`We only allow TLS certificate connections to your temporal namespace, so you need to ensure your namespace has a `}<a parentName="p" {...{
            "href": "https://docs.temporal.io/cloud/certificates"
          }}>{`certificate`}</a>{` set up. Once done, copy all the same TLS certificate values into PostHog.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the next page, set up the schemas you want to sync and modify the method and frequency as needed. Once done, click `}<strong parentName="p">{`Import`}</strong>{`.`}</p>
      </li>
    </ol>
    <p>{`Once the syncs are complete, you can start using Temporal.io data in PostHog.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      